/* eslint-disable react/no-children-prop, react/jsx-wrap-multilines */
import React from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
//@ts-ignore
import LKButton from 'shared/LKButton'
import { colors } from 'shared'
//@ts-ignore
import LKPrintButton, { constants as LKPrintButtonConstants } from 'shared/LKPrintButton'
import ClientBlackListModal, {
  open as openBlackListModalUndisp,
  getPending as getBlackListPending,
  //@ts-ignore
} from 'shared/Modals/ClientBlackListModal'
import ClientWatchlistModal, {
  open as openWatchlistModalUndisp,
  getPending as getWatchlistPending,
  //@ts-ignore
} from 'shared/Modals/ClientWatchlistModal'
//@ts-ignore
import ClientRatingModal, { open as openRatingModalUndisp } from 'shared/Modals/ClientRatingModal'
//@ts-ignore
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import Window from 'loankeeper-common/components/Window'
import { actions as DetailsContainerActions } from '../DetailsContainer'
import { translateBase, translateWebMessages } from './helpers'
import ClientEdit, { ClientEditTrigger } from '../ClientEdit'
import { ModalFooterProps } from './types'

const WindowFooter = styled(Window.Footer)`
  .ui.button.lk-button {
    &.skull-button {
      background-color: ${colors.black} !important;
      font-weight: bold;
      color: white;
    }

    &.watched-button {
      background-color: ${colors.grey} !important;
      font-weight: bold;
      color: white;
    }
  }
`

@withConstantPermissions()
//@ts-ignore
@connect(
  (state) => ({
    blackListPending: getBlackListPending(state),
    watchlistPending: getWatchlistPending(state),
  }),
  (dispatch, props: any) =>
    bindActionCreators(
      {
        openBlackListModal: (ID, hash, black) =>
          openBlackListModalUndisp(ID, hash, black, () =>
            dispatch(DetailsContainerActions.fetchPage({ type: 'Client', ID, hash, page: 'base' })),
          ),
        openWatchlistModal: (ID, hash, watched) =>
          openWatchlistModalUndisp(ID, hash, watched, () =>
            dispatch(DetailsContainerActions.fetchPage({ type: 'Client', ID, hash, page: 'base' })),
          ),
        openRatingModal: (ID, hash, FullName) => openRatingModalUndisp(ID, hash, FullName),
        updateClient: () =>
          DetailsContainerActions.fetchPage({ type: 'Client', ID: props.ID, hash: props.hash, page: 'base' }),
      },
      dispatch,
    ),
)
class Footer extends React.PureComponent<ModalFooterProps> {
  onBlackListClick = () => {
    const {
      ID,
      hash,
      data: { Black },
      openBlackListModal,
    } = this.props

    openBlackListModal(ID, hash, Black)
  }

  onRatingClick = () => {
    const {
      ID,
      hash,
      data: { FullName },
      openRatingModal,
    } = this.props

    openRatingModal(ID, hash, FullName)
  }

  alertOnWatchlistClick = () => {
    const {
      ID,
      hash,
      data: { Watched },
      openWatchlistModal,
    } = this.props

    openWatchlistModal(ID, hash, Watched)
  }

  render() {
    const { hash, data, blackListPending, watchlistPending, onRefresh, updateClient, permissions } = this.props
    return (
      <>
        <ClientBlackListModal />
        <ClientWatchlistModal />
        <ClientRatingModal />
        <ClientEdit name="ClientEditInClientDetails" onClientEdit={updateClient} />
        <WindowFooter
          actions={
            <>
              {permissions.EDIT_CLIENT && (
                <ClientEditTrigger
                  name="ClientEditInClientDetails"
                  ID={data.ID}
                  hash={hash}
                  clientType={data.ClientTypeID}
                >
                  {translateBase('cmd_edit_client')}
                </ClientEditTrigger>
              )}
              {data.Black === 1 && (
                <LKButton alias="skull" className="skull-button">
                  {translateBase('pan_state_color')}
                </LKButton>
              )}

              {data.Watched === 1 && (
                <LKButton alias="alert" className="watched-button">
                  {translateWebMessages('pan_watchlisted')}
                </LKButton>
              )}
            </>
          }
          sideActions={
            <>
              <LKPrintButton
                type={LKPrintButtonConstants.types.client}
                ID={data.ID}
                hash={hash}
                page="printclientdetails"
                upward
              />
              <LKButton alias="star" onClick={this.onRatingClick} />
              <LKButton
                alias="skull"
                onClick={this.onBlackListClick}
                loading={blackListPending}
                disabled={blackListPending}
                permission="BLACKLIST_CLIENT"
              />
              <LKButton
                alias="alert"
                onClick={this.alertOnWatchlistClick}
                loading={watchlistPending}
                disabled={watchlistPending}
                permission={data.Watched !== 1 ? 'ADD_CLIENT_WATCHLIST' : 'DELETE_CLIENT_WATCHLIST'}
              />
              <LKButton alias="refresh" onClick={onRefresh} />
            </>
          }
        />
      </>
    )
  }
}

export default Footer
